export default __webpack_public_path__ + "images/BF.e4b9293.png";